export const state = () => {
  return {
    loading: false,
    xhrLoading: false,
    secondThemePosition: 2,
    resetThemeCarousel: false,
    showLanguageMenu: false,
    obsSourceTitle: '',
    obsFontFamily: 'Arial'
  }
}

export const mutations = {
  SET_LOADING (state, value = true) {
    state.loading = value
  },
  SET_XHR_LOADING (state, value = true) {
    state.xhrLoading = value
  },
  INCREMENT_THEME_POSITION (state) {
    state.secondThemePosition++
    state.resetThemeCarousel = false
  },
  RESET_THEME_POSITION (state) {
    state.secondThemePosition = 2
    state.resetThemeCarousel = true
  },
  SET_LANGUAGE_MENU (state, value = false) {
    state.showLanguageMenu = value
  },
  SET_OBS_SOURCE_TITLE (state, title) {
    state.obsSourceTitle = title
  },
  SET_OBS_FONT_FAMILY (state, family) {
    state.obsFontFamily = family
  }
}

export const actions = {
  logout ({ commit }, onLogout) {
    return this.$auth.logout()
      .then(() => {
        commit('SET_XHR_LOADING')

        if (typeof onLogout === 'function') {
          onLogout()
        }

        window.setTimeout(() => {
          commit('SET_XHR_LOADING', false)
        }, 100)
      })
  }
}
